module.exports = __webpack_public_path__ + "img/img-quienes-somos.8f74a56c.png";